import PublicLayout from "layout/PublicLayout";
import React from "react";
import { Outlet } from "react-router-dom";

const Home = React.lazy(() => import("../pages/home/Home"));
const Features = React.lazy(() => import("../pages/features/Features"));
const WhyUs = React.lazy(() => import("../pages/whyus/WhyUs"));
const ReadMore = React.lazy(() => import("../pages/readmore/HowItWorks"));
const PrivacyPolicy = React.lazy(() => import("pages/PrivacyPolicy"));
const Faq = React.lazy(() => import("pages/faq/Faqsection"));
const TermsAndCondition = React.lazy(()=> import("pages/TermsAndCondition"))

const pubilcRoutes = {
  path: "/",
  element: (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  ),
  children: [
    {
      index: true,
      element: <Home />,
    },
    {
      path: "features",
      element: <Features />,
    },
    {
      path: "whyus",
      element: <WhyUs />,
    },
    {
      path: "readmore",
      element: <ReadMore />,
    },
    {
      path: "privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "terms-n-condition",
      element: <TermsAndCondition />,
    },
    {
      path:"faq",
      element:<Faq/>
    }
  ],
};

export default pubilcRoutes;
